class LoyaltyRewardsBirthdayModal extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.waitForLoyaltyLion()
  }

  waitForLoyaltyLion () {
    let attempts = 0
    const maxAttempts = 20 // ~2s if interval is 100ms

    const interval = setInterval(() => {
      attempts++

      const modal = document.querySelector('.lion-birthday-action')
      const success = document.querySelector('.lion-birthday-action__success')
      const disabledButton = document.querySelector(
        '.lion-action-button--disabled',
      )

      const ready = modal || success || disabledButton

      if (ready || attempts >= maxAttempts) {
        clearInterval(interval)

        this.setupBirthdayModal()
        this.setupSuccessState()
        this.checkDisabledState()
      }
    }, 800)
  }

  setupBirthdayModal () {
    const modal = document.querySelector('.lion-birthday-action')

    if (!modal) return

    const helpElement = modal.querySelector('.lion-birthday-action__help')

    if (
      helpElement &&
      !modal.querySelector('.lion-birthday-action__help-new')
    ) {
      const newDiv = document.createElement('div')
      newDiv.className = 'lion-birthday-action__help-new'
      newDiv.textContent = this.dataset.textEnter

      helpElement.insertAdjacentElement('afterend', newDiv)
    }
  }

  setupSuccessState () {
    const successElement = document.querySelector(
      '.lion-birthday-action__success',
    )

    if (!successElement) return

    document.querySelector('.lion-birthday-action__help-new')?.remove()

    if (!document.querySelector('.lion-birthday-action__success-new')) {
      const newDiv = document.createElement('div')
      newDiv.className = 'lion-birthday-action__success-new'
      newDiv.textContent = this.dataset.textSuccess

      successElement.insertAdjacentElement('afterend', newDiv)

      this.externalEls.button?.elements.forEach((button) => {
        button.textContent = button.dataset.completedText
        button.parentElement?.classList.add('blk-Reward_Button-complete')
      })
    }
  }

  checkDisabledState () {
    const disabledButton = document.querySelector(
      '.lion-action-button--disabled',
    )

    if (!disabledButton) return

    this.externalEls.button?.elements.forEach((button) => {
      button.textContent = button.dataset.completedText
      button.parentElement?.classList.add('blk-Reward_Button-complete')
    })
  }
}

if (!customElements.get('loyalty-rewards-birthday-modal')) {
  customElements.define(
    'loyalty-rewards-birthday-modal',
    LoyaltyRewardsBirthdayModal,
  )
}
